import {useFetchData} from 'hooks/api/useFetchData'

export const useFetchHasNotifications = () => {
  const path = '/api/alert_notifications/has_notifications'
  return useFetchData<boolean>(path, false, {})
}
